module.exports = __webpack_public_path__ + "static/img/badge-spray-reminder-active.5391467.svg";